$(document).ready(function () {
  let servicePicSwiper = null; // 服务业态 轮播图实例
  let serviceContSwiper = null // 服务业态 PC轮播图描述实例
  let marketSwiper = null; // 市场情况 轮播实例
  let categoryList = []; // 新闻分类列表

  /* 获取分类列表 */
  function getNewsCategoryList() {
    return $.get(
      getAjaxUrl() + '/web/News/getNewsCategory',
      ({ data, errorcode, errormsg }) => {
        if (errorcode === 0) {
          categoryList = [{ name: '全部新闻', id: '' }, ...data.list.reverse().slice(0, 5)]; // 1 + 5;
          let el = '';
          categoryList.forEach(v => {
            el += (
              `<div class="news-card-item">
                <div class="news-img-box">
                  <img class="news-img" src="https://imagecdn.rocketbird.cn/official/image/new/index/official-information.png" alt="${ v.name }">
                </div>
                <h3 class="news-card-title">${ v.name }</h3>
                <ul class="news-title-list">
                  <li class="news-title no-data">暂无数据</li>
                </ul>
              </div>`
            )
          })
          $('.news-container .news-card-list').html(el)
        } else {
          console.log(errormsg);
        }
      }
    );
  }
  /* 获取分类下新闻列表 */
  function getNewsList() {
    const newsListBox = $('.news-container .news-card-list .news-title-list');
    const newsImgBox = $('.news-container .news-card-list .news-img-box');

    categoryList.forEach((v, i) => {
      $.post(
        getAjaxUrl() + '/Web/News/getNewsLists', { news_category_id: v.id, page_no: 1, page_size: 3 }, 
        ({ data, errorcode, errormsg }) => {
          if (errorcode === 0) {
            const newList = data.list.slice(0, 3);
            if (newList.length) {
              let el = '';
              newList.forEach(k => {
                const [_, month, day] = k.create_time.split('-');
                el += (
                  `<li class="news-title text_overflow">
                    <a class="news-link" href="./news_detail.html?c=${ k.news_category_id || v.id }&i=${ k.id }">
                      <span class="news-date">${ month.padStart(2, 0) }.${ day.padStart(2, 0) } </span>
                      ${ k.title }
                    </a>
                  </li>`
                );
              })
              i !== 0 && ( newsImgBox[i].innerHTML = `<img class="news-img" src="${ newList[0].images }" alt="${ v.name }">`);
              newsListBox[i].innerHTML = el;
            }
          } else {
            console.log(errormsg);
          }
        }
      );
    })
  }

  /* 初始化移动端 服务业态 部分 */
  function initMobileService() {
    try {
      $(".service-container .wrap").show()
      servicePicSwiper = new Swiper ('.service-picture-box', {
        effect: 'coverflow',
        slidesPerView: 'auto',
        centeredSlides: true, // 居中幻灯片。设定为true时，当前的active slide 会居中，而不是默认状态下的居左。
        coverflowEffect: {
          rotate: 0, // slide做3d旋转时Y轴的旋转角度
          stretch: 177, // 每个slide之间的拉伸值，越大slide靠得越紧, 可百分比
          depth: 200, // slide的位置深度。值越大z轴距离越远，看起来越小。
          modifier: 1, // depth和rotate和stretch的倍率，相当于depth*modifier、rotate*modifier、stretch*modifier，值越大这三个参数的效果越明显。
          slideShadows: false, // 是否开启slide阴影 自定义实现
        },
        loop: true, // 循环模式选项
        autoplay: {
          delay: 5 * 1000, 
          disableOnInteraction: false, // 用户操作swiper之后，是否禁止autoplay。默认为true：停止。
        },
        speed: 300,
        grabCursor: true,
        slideActiveClass: 'active',
      })
    } catch (error) {
      console.log(error);
    }
  }
  /* 初始化移动端 勤鸟资讯 部分 */
  function initMobileNews() {
    try {
      $('.news-more-btn').text('查看更多');
      // 处理勤鸟资讯 区域渲染
      getNewsCategoryList().then(getNewsList)
    } catch (error) {
      console.log(error);
    }
  }
  /* 初始化移动端 市场情况 部分 */
  function initMobileMarket() {
    try {
      marketSwiper = new Swiper ('.market-img-wrapper', {
        autoplay: {
          delay: 5 * 1000, 
        },
        speed: 500,
        loop: true, // 循环模式选项
        
        // 如果需要分页器
        pagination: {
          el: '.swiper-pagination',
          /* 自定义分页器按钮样式 */
          // type : 'custom',
          bulletElement : 'div',
          bulletClass: 'market-btn',
          bulletActiveClass: 'active',
          currentClass: 'active',
          clickable: true,
        },
      })
    } catch (error) {
      console.log(error);
    }
  }

  /* 初始化桌面端 服务业态 部分 */
  function initPCService() {
    try {
      $(".service-container .wrap").html(
        `<div class="service-detail-wrapper">
          <div class="service-detail">
            <div class="left-box">
              <!-- <div id="swipeArrowPrevTop" style="display: none;"></div> -->
              <div class="service-picture-box">
                <ul class="service-picture-list swiper-wrapper">
                  <li class="service-picture-item swiper-slide active">
                    <a class="service-item-link" href="./product.html#explorationSection">
                      <img class="service-picture" src="https://imagecdn.rocketbird.cn/official/image/new/index/swipe-01.png" alt="健身房">
                    </a>
                  </li>
                  <li class="service-picture-item swiper-slide">
                    <a class="service-item-link" href="./product.html#explorationSection">
                      <img class="service-picture" src="https://imagecdn.rocketbird.cn/official/image/new/index/swipe-02.png" alt="工作室">
                    </a>
                  </li>
                  <li class="service-picture-item swiper-slide">
                    <a class="service-item-link" href="./product.html#explorationSection">
                      <img class="service-picture" src="https://imagecdn.rocketbird.cn/official/image/new/index/swipe-03.png" alt="体育中心">
                    </a>
                  </li>
                  <li class="service-picture-item swiper-slide">
                    <a class="service-item-link" href="./product.html#explorationSection">
                      <img class="service-picture" src="https://imagecdn.rocketbird.cn/official/image/new/index/swipe-04.png" alt="房地产">
                    </a>
                  </li>
                </ul>
              </div>
              <!-- <div id="swipeArrowNextTop" style="display: none;"></div> -->
            </div>
            <div class="right-box">
              <div class="service-info-box">
                <ul class="service-info-list swiper-wrapper">
                  <li class="service-info-item swiper-slide active">
                    <h3 class="service-info-title">健身房</h3>
                    <p class="service-info-text">
                      <span>综合健身房、</span>
                      <span>游泳馆、</span>
                      <span>24H健身房、</span><br/>
                      <span>政企健身房、</span>
                      <span>酒店健身房...</span>
                    </p>
                  </li>
                  <li class="service-info-item swiper-slide">
                    <h3 class="service-info-title">工作室</h3>
                    <p class="service-info-text">
                      <span>私教工作室、</span>
                      <span>瑜伽馆、</span>
                      <span>舞蹈室、</span><br/>
                      <span>武道馆、</span>
                      <span>拳击馆..</span>
                    </p>
                  </li>
                  <li class="service-info-item swiper-slide">
                    <h3 class="service-info-title">体育运动中心</h3>
                    <p class="service-info-text">
                      <span>大型综合体育中心、</span>
                      <span>各类球馆、</span>
                      <span>滑雪场、</span><br/>
                      <span>溜冰场、</span>
                      <span>户外运动场地...</span>
                    </p>
                  </li>
                  <li class="service-info-item swiper-slide">
                    <h3 class="service-info-title">地产会所</h3>
                    <p class="service-info-text">
                      <span>综合房地产健身业态...</span>
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="service-detail-text-bg">
            <span>GYM</span>
            <span>STUDIO</span>
            <span>STADIUM</span>
          </div>
        </div>
        <div class="service-thumbs-warpper">
          <div class="arrow-btn left-btn-bg swiper-btn-prev">
            <!-- <img class="arrow-img" src="https://imagecdn.rocketbird.cn/official/image/new/index/arrow-left.png" alt="左"> -->
          </div>
          <div class="service-thumbs-box">
            <ul class="service-thumbs-list swiper-wrapper">
              <li class="service-thumbs-item swiper-slide active">
                <div class="service-thumbs-img-box">
                  <img class="service-thumbs-img" src="https://imagecdn.rocketbird.cn/official/image/new/index/swipe-01.png" alt="健身房">
                </div>
                <h4>健身房</h4>
              </li>
              <li class="service-thumbs-item swiper-slide">
                <div class="service-thumbs-img-box">
                  <img class="service-thumbs-img" src="https://imagecdn.rocketbird.cn/official/image/new/index/swipe-mini-02.png" alt="工作室">
                </div>
                <h4>工作室</h4>
              </li>
              <li class="service-thumbs-item swiper-slide">
                <div class="service-thumbs-img-box">
                  <img class="service-thumbs-img" src="https://imagecdn.rocketbird.cn/official/image/new/index/swipe-mini-03.png" alt="体育中心">
                </div>
                <h4>体育中心</h4>
              </li>
              <li class="service-thumbs-item swiper-slide">
                <div class="service-thumbs-img-box">
                  <img class="service-thumbs-img" src="https://imagecdn.rocketbird.cn/official/image/new/index/swipe-mini-04.png" alt="地产会所">
                </div>
                <h4>地产会所</h4>
              </li>
            </ul>
          </div>
          <div class="arrow-btn right-btn-bg swiper-btn-next">
            <!-- <img class="arrow-img" src="https://imagecdn.rocketbird.cn/official/image/new/index/arrow-right.png" alt="右"> -->
          </div>
        </div>`
      ).show();
  
      serviceContSwiper = new Swiper ('.service-info-box', {
        loop: true,
        slideActiveClass: 'active',
        allowTouchMove: false, // 设置是否允许触摸滑动
      })
      servicePicSwiper = new Swiper ('.service-picture-box', {
        loop: true, // 循环模式选项
        autoplay: {
          delay: 5 * 1000, 
          disableOnInteraction: false, // 用户操作swiper之后，是否禁止autoplay。默认为true：停止。
        },
        speed: 300,
        // grabCursor: true,
        touchRatio: 0.7, // 触摸距离与slide滑动距离的比率, 默认1
        // followFinger: false, // 跟随手指。如果禁用，当你按住手指时slide不会移动，只有当你释放时slide才会切换。
        // 如果需要同步控制其他swiper
        controller: {
          control: serviceContSwiper,
        },
        // 如果需要前进后退按钮
        navigation: {
          nextEl: '.swiper-btn-next',
          prevEl: '.swiper-btn-prev',
        },
        // 如果需要缩略图栏
        thumbs: {
          swiper: {
            el: '.service-thumbs-box', // 默认.swiper-thumbs
            slidesPerView: 4,
            spaceBetween: 0,
            watchSlidesVisibility: true,
          },
          // thumbsContainerClass: 'ul-mini-images',
          slideThumbActiveClass: 'active'
        },
        // 如果需要滚动条
        // scrollbar: {
        //   el: '.swiper-scrollbar',
        // },
      }) 
    } catch (error) {
      console.log(error);
    }
  }
  /* 初始化桌面端 勤鸟咨询 部分 */
  function initPCNews() {
    try {
      // 处理勤鸟资讯 区域渲染
      getNewsCategoryList().then(getNewsList)
    } catch (error) {
      console.log(error);
    }
  }
  /* 初始化桌面端 市场情况 部分 */
  function initPCMarket() {
    try {
      $('.market-container .wrap').html(`<img src="https://imagecdn.rocketbird.cn/official/image/new/index/market-logo.png" alt="合作伙伴logo">`);
    } catch (error) {
      console.log(error);
    }
  }
  /* 初始化桌面端 合作伙伴 部分 */
  function initPCPartner() {
    try {
      $('.partner-container .wrap').html(
        `<ul class="partner-list">
          <li class="partner-item">
            <p>泰诺健</p>
          </li>
          <li class="partner-item">
            <p>维塑</p>
          </li>
          <li class="partner-item">
            <p>必确</p>
          </li>
          <li class="partner-item">
            <p>舒华</p>
          </li>
          <li class="partner-item">
            <p>InBody</p>
          </li>
          <li class="partner-item">
            <p>巍得健身</p>
          </li>
          <li class="partner-item">
            <p>华人</p>
          </li>
          <li class="partner-item">
            <p>商汤</p>
          </li>
          <li class="partner-item">
            <p>魔点科技</p>
          </li>
          <li class="partner-item">
            <p>GYMSmart</p>
          </li>
        </ul>
        <ul class="partner-list">
          <li class="partner-item">
            <p>LES MILLS莱美</p>
          </li>
          <li class="partner-item">
            <p>爱动健身</p>
          </li>
          <li class="partner-item">
            <p>百万会籍联盟</p>
          </li>
          <li class="partner-item">
            <p>私教核武器</p>
          </li>
          <li class="partner-item">
            <p>帕纳</p>
          </li>
          <li class="partner-item">
            <p>IWF</p>
          </li>
          <li class="partner-item">
            <p>FIBO</p>
          </li>
          <li class="partner-item">
            <p>CHINAFIT</p>
          </li>
        </ul>
        <ul class="partner-list">
          <li class="partner-item">
            <p>华为运动健康</p>
          </li>
          <li class="partner-item">
            <p>佑久</p>
          </li>
          <li class="partner-item">
            <p>支付宝</p>
          </li>
          <li class="partner-item">
            <p>微信</p>
          </li>
          <li class="partner-item">
            <p>收钱吧</p>
          </li>
          <li class="partner-item">
            <p>杉德支付</p>
          </li>
          <li class="partner-item">
            <p>古德体育</p>
          </li>
          <li class="partner-item">
            <p>阿里云</p>
          </li>
          <li class="partner-item">
            <p>e签宝</p>
          </li>
        </ul>`
      );
    } catch (error) {
      console.log(error);
    }
  }


  if ($(window).width() <= 479) {
    // 处理服务轮播
    initMobileService()
    // 处理勤鸟咨询
    initMobileNews()
    // 处理市场轮播
    initMobileMarket()
  } else {
    // 处理服务轮播
    initPCService()
    // 处理勤鸟咨询
    initPCNews()
    // 处理市场轮播
    initPCMarket()
    // 处理合作伙伴
    initPCPartner()
  }

});
